import React, { Component } from "react";
import { Input, Select, Pagination,  Table,Spin, Modal } from "antd";
import Api from "../../../ServiceApi";
import EmployeeStatus from "../employee/EmployeeStatus";
import TeamTotalJobCard from "./TeamTotalJobCard";
// import EmployeeTableForTeam from "./Modal_empTableForTeam";
import Cookies from "js-cookie";
// import AssignJob from "../../../../ui/map/assign_job.js";
import ModalSuccess from "../../../../components/Modal_Success";


const { Option } = Select;

class AllTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_team_id: props.selected_team,
      team_list: props.team_list,
      team_list_filtered: props.team_list,
      team_page: 1,
      selected_team: {},
      team_filter: "",
      emp_list: [],
      ma_skill: [],
      emp_list_filtered: [],
      emp_page: 1,
      emp_filter: "",
      emp_spinner: 1,
      isTeamDetailReturned: false,
      isVisibleEmpTable: false,
      team_total_job: [],
      // for add employee table
      reloading:false,
      data_assing:[],
      selectedRowlist: [],
      setDataAssign: [],
      modal_data:[],
      addEmployeeSuccess: false,
      columns_team: [
          {
            title: "Team Group Name",
            dataIndex: "team_group_name",
            key: "team_group_name",
            // sorter: (a, b) => a.team_group_name.length - b.team_group_name.length,
          },
          {
            title: "Team Sub Name",
            dataIndex: "team_sub_name",
            key: "team_sub_name",
            // sorter: (a, b) => a.team_sub_name.length - b.team_sub_name.length,
          },
          {
            title: "Name List",
            dataIndex: "emp_name",
            key: "emp_name",
          },
          {
            title: "Status",
            dataIndex: "",
            key: "",
            render: () => (
              <span className="c-green">
                <span className="dot-active mr-2"></span>Active
              </span>
            ),
          },
          // {
          //   title: "On Hand Job",
          //   dataIndex: "current_onhand_job",
          //   key: "current_onhand_job",
          // },
        ],
    };
  }
  
  toJson(jsonString) {
    let myJSONString = JSON.parse(JSON.stringify(jsonString.data.data));
    return JSON.parse(myJSONString);
  }
  async componentDidMount() {
    this.setState({});
    const setmaskill = {
      pk_id: null,
      is_active: 1,
      effective: null,
      sql_where: "operator_id = " + Cookies.get("operator_id"),
      company_id: Cookies.get("companyid"),
      operator_id :  Cookies.get("operator_id")
    };
    const GetMaskill = await Api.post("get_ma_skill", setmaskill);
    if (GetMaskill.data.result.value === "P") {
      this.setState({ ma_skill: GetMaskill.data.data.result_ma_skill_list });
    }
    const employee_list_api = await Api.post(
      "get_team_management_employee_list",
      {
        company_id: Cookies.get("companyid"),
        operator_id:Cookies.get("operator_id"),
        project_id:Cookies.get("project_id"),
        is_active: 1,
        fk_id: this.state.selected_team_id,
      }
    )
      .then(
        (value) => {
          // let value_obj = this.toJson(value);
          this.setState({
            emp_spinner: 0,
            emp_list: value.data.data.employee_list,
            emp_list_filtered: value.data.data.employee_list,
          });
        },
        () => console.log("emp list filtered", this.state.emp_list_filtered)
      )
      .catch((error) => {
        this.setState({
          emp_spinner: 0,
        });
        console.log(error);
      });
    const team_detail_api = await Api.post("get_team_management_team_detail", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
    });
    if (team_detail_api.data.result.code === "P") {
      this.setState(
        {
          team_total_job: team_detail_api.data.data.employee_total_jobs,
          emp_spinner: 0,
          isTeamDetailReturned: true,
          team_skill: team_detail_api.data.data.team_skill,
        },
        () => console.log("team details", team_detail_api.data.data)
      );
    }
  }
  handleEmpTableForTeamVisible(isVisible) {
    console.log("reach handle visible",isVisible);
    this.setState({ isVisibleEmpTable: isVisible });
  }
  handleClickEmployee = (emp_id) => {
    console.log("handleClick Employee", emp_id);
    let temp_emp_list_filtered = [...this.state.emp_list_filtered];
    temp_emp_list_filtered = temp_emp_list_filtered.filter(
      (i) => i.emp_id !== emp_id
    );
    this.setState({
      emp_list_filtered: [...temp_emp_list_filtered],
    });
  };
  teamOnclick = (team, team_id) => {
    console.log("team is clicked", team_id, team);
    this.setState({
      emp_spinner: 1,
      selected_team_id: team_id,
    });
    //console.log(this.getEmpdetail(employee));
    const employee_list_api = Api.post("get_team_management_employee_list", {
      is_active: 1,
      fk_id: team_id,
      company_id: Cookies.get("companyid"),
      operator_id:Cookies.get("operator_id"),
      project_id:Cookies.get("project_id"),
    })
      .then((value) => {
        // let value_obj = this.toJson(value);
        console.log("value from team", value);
        this.setState({
          emp_spinner: 0,
          emp_list: value.data.data.employee_list,
          emp_list_filtered: value.data.data.employee_list,
        });
      })
      .catch((error) => {
        this.setState({
          emp_spinner: 0,
        });
        console.log(error);
      });
  };

  handleTeamChange = (e) => {
    let newList = [];
    this.setState({ team_filter: e.target.value });
    if (e.target.value !== "") {
      newList = this.state.team_list.filter((item) => {
        return item.team_name
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
    } else {
      newList = this.state.team_list;
    }
    this.setState(
      {
        team_list_filtered: newList,
        team_page: 1,
      },
      () => {
        console.log("filter", this.state.team_list_filtered);
      }
    );
  };
  handleEmpChange = (e) => {
    let newList = [];
    this.setState({ emp_filter: e.target.value });
    if (e.target.value !== "") {
      newList = this.state.emp_list.filter((item) => {
        return item.emp_name
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
    } else {
      newList = this.state.emp_list;
    }
    this.setState({
      emp_list_filtered: newList,
      emp_page: 1,
    });
  };
  onChangeEmp = async (val, obj) => {
    this.setState({
      data_assing: [],
      reloading: true,
    })
    var setTab = ["", "employee", "team"];
    const getTeamAssign = await Api.post("get_assign_job_ma", {
      select: "team",
      skill_id: val,
      team_id: null,
      sql_where: "operator_id="+Cookies.get("operator_id"),
      company_id: Cookies.get("companyid"),
    });

    // console.log(getTeamAssign.data.data);
    // if (this.state.Checktab === "1" || this.state.Checktab === 1) {
    //   for (
    //     var i = 0;
    //     i < getTeamAssign.data.data.result_list_ma_employee.length;
    //     i++
    //   ) {
    //     getTeamAssign.data.data.result_list_ma_employee[i]["key"] = i;
    //   }
    //    this.setState({
    //     data_assing: getTeamAssign.data.data.result_list_ma_employee,
    //     reloading: false
    //   });
    // }
      for (
        let i = 0;
        i < getTeamAssign.data.data.result_list_ma_team.length;
        i++
      ) {
        getTeamAssign.data.data.result_list_ma_team[i]["key"] = i;
      }
      this.setState({
        data_assing: getTeamAssign.data.data.result_list_ma_team,
        reloading: false
      });
  };
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const {Checktab, default_key} = this.state

    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    this.setState({selectedRowKeys})
    this.setState({
      setDataAssign: selectedRows,
    });
  }
  async handleSubmit(){
    this.state.setDataAssign.forEach(i => {
      i.i_is_active = 1
      // i.effective_date="testDate"
      delete i["key"]
    })
    console.log('this.state assign', this.state.setDataAssign)
    const respond = Api.post("update_sub_employee", {data: this.state.setDataAssign}).then(res => {
      console.log('res', res)
      if(res.data.result.code === "P"){
        this.setState({addEmployeeSuccess : true})
      }
    })
    this.handleEmpTableForTeamVisible(false)
  }
  renderModalAssign() {
    const {
      employee,
      team,
      visible,
      job_id,
      columns,
      setDataAssign,
      Checktab,
      default_key,
      selectedRowKeys,
      selectedRows, 
      reloading,
      selectedRowlist,
    } = this.state;

    const rowSelection = {  
      selectedRowKeys,
      selectedRows, 
      onChange: this.onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    const rowSelectionList = {
      selectedRowlist,
      onChange: (selectedRowlist, selectedRows) => {
        console.log('row list row', selectedRowlist, selectedRows)
        this.setState({ selectedRowlist: selectedRows });
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    return (
      <Modal
        title="Add Employee"
        centered
        visible={true}
        footer={null}
        closable={false}
        className="custom-modal-map-large"
      >
            <div style={{margin:"1rem"}}>
              <Spin spinning={reloading}>
                {/* <h3 className="font-mont-b fs-16 c-blue text-uppercase">
                  Add Employee
                </h3> */}
                    <div className="row">
                      <div className="col-3">
                        <label className="labeaddjob mt-1">
                          Team Skill <b style={{ color: "#DF4547" }}> * </b>
                        </label>{" "}
                      </div>
                      <div className="col">
                        <Select
                          showSearch
                          style={{ border: "0px", width: "50%" }}
                          placeholder="Select a Team Skill"
                          className="inputfile"
                          onChange={this.onChangeEmp}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children === "" || option.children === null
                              ? null
                              : option.children
                                  .toLowerCase()
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.state.ma_skill.map((item, index) => (
                            <Select.Option
                              value={item.ma_skill_id}
                              key={index}
                              obj={item}
                              type_sc="team_skill"
                            >
                              {item.ma_skill_name}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <Table
                      //  className={css(tableCSS)}
                      size="small"
                      rowKey="team_id"
                      rowSelection={rowSelection}
                      columns={this.state.columns_team}
                      dataSource={!this.state.data_assing? null:  this.state.data_assing}
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                      // pagination={false}
                    />

                <div className="mt-4 text-center">
                  <button
                    type="reset"
                    onClick={() => this.handleEmpTableForTeamVisible(false)}
                    className="btn btn-secondary"
                  >
                    Close
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => this.handleSubmit()}
                  >
                    Confirm
                  </button>
                </div>
              </Spin>
            </div>
      </Modal>
    );
  }
  render() {
    const {
      team_filter,
      emp_filter,
      selected_team_id,
      emp_list,
      isTeamDetailReturned,
      team_total_job,
      team_skill,
      reloading,
    } = this.state;
    function isNull(a, type) {
      //type null:text,1:number
      return !a ? (!type ? "-" : "0") : a;
    }
    let count = 0;
    return (
      <div style={{ padding: "20px" }}>
        <div className="row">
          <div className="col-3">
            {/* input for search team name */}
            <Input
              value={team_filter}
              className="mb-4"
              placeholder="Search team name"
              suffix={<img src={Api.absoluteUrl("/icon/search.svg")} alt="" />}
              onChange={this.handleTeamChange}
            />
            {/* the card tab for left side of the page */}
            {this.state.team_list_filtered.map((item, index) => {
              {
                /* console.log('item ', item) */
              }
              return index + 1 >= this.state.team_page * 7 - 6 &&
                index + 1 <= this.state.team_page * 7 ? (
                <div
                  key={item.team_id}
                  className={
                    selected_team_id === item.team_id
                      ? "card-team-select active"
                      : "card-team-select"
                  }
                  onClick={() => this.teamOnclick(item, item.team_id)}
                >
                  <button className="w-100 d-flex justify-content-between">
                    <div>
                      <h5 className="font-thai-b fs-18 m-0">
                        {item.team_name}
                      </h5>
                      <span className="font-thai-b fs-18">
                        {item.team_group_name}
                      </span>
                    </div>
                    <span className="font-thai-b fs-16">
                      {/* ({item.emp_in_team} Employees) */}
                      (10 Employees)
                    </span>
                  </button>
                </div>
              ) : (
                ""
              );
            })}
            {/* pagination for list on the left */}
            {
              <Pagination
                className="text-right"
                onChange={(page) => this.setState({ team_page: page })}
                showSizeChanger={false}
                size="small"
                current={this.state.team_page}
                defaultPageSize={7}
                total={this.state.team_list_filtered.length}
                showTotal={() => {
                  return "Total " + this.state.team_list.length + " teams";
                }}
              />
            }
          </div>
          <div className="col-9">
            <div className="row mb-4">
              {/* profile picture */}
              <div className="col-2">
                <img
                  src={Api.absoluteUrl("/img/pic_employee.png")}
                  className="img-fluid"
                />
              </div>
              <div className="col-9">
                <div className="row">
                  <div className="col-9">
                    <h3 className="font-mont-b fs-20 c-blue text-uppercase my-4">
                      {
                        this.state.team_list.find(
                          (x) => x.team_id === selected_team_id
                        ).team_name
                      }
                    </h3>
                  </div>
                  <div className="col-3">
                    <a
                      href="#"
                      className="btn btn-warning"
                      onClick={() => this.handleEmpTableForTeamVisible(true)}
                    >
                      <img
                        src={Api.absoluteUrl("/icon/add_job.svg")}
                        width="14"
                        className="mr-2"
                      />
                      <span>Add Employee</span>
                    </a>
                  </div>
                </div>

                <h4 className="font-thai-b fs-18">Department/ Area</h4>
                {this.state.emp_list_filtered.map((item) => {
                  if (
                    item.employee_position_name === "Team Lead" &&
                    count <= 2
                  ) {
                    count += count + 1;
                    return (
                      <div className="row">
                        <div className="d-flex justify-content-between align-items-center mb-1 col-12">
                          <div className="col-3">
                            <div className="font-thai-sb fs-18">
                              <img
                                src={Api.absoluteUrl("/icon/people.svg")}
                                alt=""
                                className="mr-2"
                              />
                              {item.emp_name}
                            </div>
                          </div>
                          {/* job */}
                          <div className="col-3">
                            <div className="font-thai-sb fs-18">
                              <img
                                src={Api.absoluteUrl("/icon/position.svg")}
                                alt=""
                                className="mr-2"
                              />
                              {isNull(item.employee_position_name)}
                              {/* Senior Engineer */}
                            </div>
                          </div>
                          {/* email */}
                          <div className="col-3">
                            <div className="font-thai-sb fs-18">
                              <img
                                src={Api.absoluteUrl("/icon/mail.svg")}
                                alt=""
                                className="mr-2"
                              />
                              {isNull(item.email)}
                            </div>
                          </div>
                          {/* phone number */}
                          <div className="col-3">
                            <div className="font-thai-sb fs-18">
                              <img
                                src={Api.absoluteUrl("/icon/phone.svg")}
                                alt=""
                                className="mr-2"
                              />
                              {isNull(item.tel)}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
                {/* team lead */}

                {/* <div className="row">
                  <div className="d-flex justify-content-between align-items-center mb-3 col-12">
                     <div className="col-3">
                    <div
                      className="font-thai-sb fs-18"
                    >

                        <img
                          src={Api.absoluteUrl("/icon/people.svg")}
                          alt=""
                          className="mr-2"
                        />
                          นัท (Head inMall)
                    </div>
                  </div>
                    <div className="col-3">
                      <div className="font-thai-sb fs-18">
                      <img
                          src={Api.absoluteUrl("/icon/position.svg")}
                          alt=""
                          className="mr-2"
                        />
                        Senior Engineer
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="font-thai-sb fs-18">
                      <img
                          src={Api.absoluteUrl("/icon/mail.svg")}
                          alt=""
                          className="mr-2"
                        />
                        {isNull("nut@planb.com")}
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="font-thai-sb fs-18">
                        <img
                          src={Api.absoluteUrl("/icon/phone.svg")}
                          alt=""
                          className="mr-2"
                        />
                        {isNull("087-603-8468")}
                      </div>
                    </div>
                  </div>
                </div>*/}
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                {isTeamDetailReturned ? (
                  <TeamTotalJobCard teamTotalJob={team_total_job} />
                ) : (
                  ""
                )}
              </div>
              {/* <EmployeeStatus statusData={} /> */}
              <EmployeeStatus />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              {/* input for search employee name */}
              {/* <Input
                placeholder="Search Employee Name"
                value={emp_filter}
                style={{ width: 300 }}
                suffix={
                  <img src={Api.absoluteUrl("/icon/search.svg")} alt="" />
                }
                onChange={this.handleEmpChange}
              /> */}
            </div>
            <div className="mb-4">
              {/* Skill title */}
              <h3 className="font-mont-b fs-20 c-blue text-uppercase">
                <img
                  src={Api.absoluteUrl("/icon/skill.svg")}
                  className="mr-2"
                  width="26"
                  alt=""
                />
                Skill
              </h3>
              <ul className="tag-skill">
                {isTeamDetailReturned ? (
                  team_skill.length === 0 ? (
                    <li>-</li>
                  ) : (
                    team_skill.map((item, index) => {
                      console.log("item", item);
                      return <li key={index}>{item.ma_skill_name}</li>;
                    })
                  )
                ) : (
                  ""
                )}
              </ul>
            </div>

            {/* employee title */}
            <h3 className="font-mont-b fs-20 c-blue text-uppercase my-4">
              <img
                src={Api.absoluteUrl("/icon/people_large.svg")}
                alt=""
                className="mr-2"
              />
              Employee
            </h3>
            <div className="row mb-3">
              {this.state.emp_list_filtered.map((emp, index) => {
                {
                  /* console.log(
                  "this.state.emp_list_filtered",
                  emp
                ); */
                }
                return index + 1 >= this.state.emp_page * 8 - 7 &&
                  index + 1 <= this.state.emp_page * 8 ? (
                  <div key={index} className="col-3 mb-2">
                    <div className="card-employee">
                      <div className="text-right">
                        {/* dropdown for edit and delete */}
                        {/* <Dropdown */}
                        {/* overlay={
                            <Menu>
                              <Menu.Item key="0">
                                <a>
                                  <img
                                    src={Api.absoluteUrl(
                                      "/icon/rename_dropdown.svg"
                                    )}
                                    className="mr-2"
                                  />
                                  Edit
                                </a>
                              </Menu.Item>
                              <Menu.Item key="1"> */}
                        <a
                          className="c-red"
                          onClick={() => this.handleClickEmployee(emp.emp_id)}
                        >
                          <img
                            src={Api.absoluteUrl("/icon/delete_dropdown.svg")}
                            className="mr-2"
                          />
                        </a>
                        {/* </Menu.Item>
                            </Menu>
                          }
                          trigger={["click"]}
                        > */}
                        {/* <a
                            className="ant-dropdown-link c-blue"
                            onClick={(e) => e.preventDefault()}
                          > */}
                        {/* <svg
                              className="bi bi-three-dots"
                              width="1em"
                              height="1em"
                              viewBox="0 0 16 16"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
                        </Dropdown> */}
                      </div>
                      <img src={Api.absoluteUrl("/img/1.png")} alt="" />
                      <h5 className="font-thai-b fs-18 c-blue mt-2 mb-0">
                        {emp.emp_name}
                      </h5>
                      <span className="font-thai-b fs-18">
                        {emp.employee_position_name}
                      </span>
                      <ul>
                        <li>
                          <img
                            src={Api.absoluteUrl("/icon/clock.svg")}
                            alt=""
                            className="mr-2"
                          />
                          <span className="font-thai-sb fs-18">
                            {isNull(emp.employee_shift_name)}
                          </span>
                        </li>
                        <li>
                          <img
                            src={Api.absoluteUrl("/icon/mail.svg")}
                            alt=""
                            className="mr-2"
                          />
                          <span className="font-thai-sb fs-18">
                            {isNull(emp.email)}
                          </span>
                        </li>
                        <li>
                          <img
                            src={Api.absoluteUrl("/icon/phone.svg")}
                            alt=""
                            className="mr-2"
                          />
                          <span className="font-thai-sb fs-18">
                            {isNull(emp.tel)}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                );
              })}
            </div>

            <Pagination
              className="text-right position-absolute"
              style={{ bottom: 0, right: 5 }}
              showSizeChanger={false}
              size="small"
              current={this.state.emp_page}
              defaultPageSize={8}
              /*onChange={(page) => this.setState({team_page:page})}*/
              total={this.state.emp_list_filtered.length}
              showTotal={() => {
                return (
                  "Total " +
                  this.state.emp_list.length +
                  " Members in team " +
                  (!this.state.team_list.find(
                    (x) => x.team_id === selected_team_id
                  )
                    ? ""
                    : "'" +
                      this.state.team_list.find(
                        (x) => x.team_id === selected_team_id
                      ).team_name +
                      "'")
                );
              }}
            />

            {this.state.emp_spinner === 1 ? (
              <div>
                <div
                  className="position-absolute"
                  style={{
                    backgroundColor: "#505050",
                    opacity: 0.1,
                    height: "calc(100% - 50px)",
                    width: "100%",
                    top: 50,
                    left: 0,
                    zIndex: 1000,
                  }}
                ></div>
                <div
                  className="spinner-border position-absolute"
                  style={{
                    width: "15rem",
                    height: "15rem",
                    top: "calc(50% - 7.5rem)",
                    left: "calc(50% - 7.5rem)",
                    zIndex: 1001,
                  }}
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {this.state.isVisibleEmpTable ? this.renderModalAssign(): ""}
        {this.state.addEmployeeSuccess ? <ModalSuccess status="Add Employee" path_location="/MaxiOperation/team_management" /> : ""}
      </div>
    );
  }
}

export default AllTeam;
